import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-zoom-out",
  templateUrl: "./med-icon-zoom-out.component.html",
})
export class MedIconZoomOutComponent extends SvgMixinComponent {}
